<template>
    <div class="UniversalPay">
        <div class="pay_all">
            <div class="Pay_header">
                <div class="OpenCard_header_title">
                    <p>支付</p>
                </div>
            </div>
            <div class="Pay_content">
                <div class="Pay_content_price">
                    <div class="Pay_content_price_logo">
                        <img src="~@/assets/images/pay/logo.png" alt="" />
                    </div>
                    <div class="Pay_content_right">
                        <p>
                            手机号：<span>{{ serviceid }}</span>
                        </p>
                        <p>
                            需充值: <span>{{ amount }}</span>元
                        </p>
                    </div>
                </div>

                <div class="Pay_content_mode">
                    <p class="title">支付方式</p>
                    <section class="selectPay">
                        <ul class="payBox active" id="payBox">
                            <li class="payWay">
                                <div class="payWay_left">
                                    <img src="../../assets/images/pay/wx1.png" />
                                    <span>微信支付</span>
                                </div>
                                <span class="active"></span>
                            </li>
                        </ul>
                    </section>
                </div>

                <div class="btn">
                    <button @click="openPay">缴费</button>
                </div>
            </div>
        </div>
        <div class="login_tu" v-if="Judge == 'micromessenger'">
            <p>点击右上角在浏览器中打开</p>
        </div>
        <div class="login_tus" v-if="Judge == 'unknown'">
            <p>该系统暂不支持开卡</p>
        </div>
    </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import env from '../../common/newapi/env.js'
import Lanmao from "../../components/lanmao/index"
import { getUrlKey } from '../../common/utils/router'
import { WxBossPay, BossQueryOrderByOutTradeNo } from "../../common/newapi/api.js"
export default {
    components: {},
    data() {
        return {
            recordNumber: "",
            serviceid: "",
            amount: "",
            Judge: null,
        }
    },

    created() {
        // this.judge()
        this.QueryPayData()
        this.WxPayQuery()

    },
    // 组件方法
    methods: {

        judge() {
            let ua = window.navigator.userAgent.toLowerCase()
            // 判断用户手机是否为苹果安卓手机
            if (
                ua.match(/android/i) == "android" ||
                ua.match(/iphone os/i) == "iphone os"
            ) {
                // 用户手机为安卓手机在判断是否在微信浏览器中打开
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    // 微信浏览器中打开
                    this.Judge = "micromessenger"
                } else {
                    this.Judge = "android"
                    this.QueryPayData()
                }
            } else {
                alert("该系统暂不支持开卡")
                this.Judge = "unknown"
            }
        },

        // 获取url参数
        QueryPayData() {
            this.recordNumber = getUrlKey('recordNumber')
            this.serviceid = getUrlKey('serviceid')
            this.amount = getUrlKey('amount')
        },

        // BOSS微信支付查询
        async WxPayQuery() {
            if (localStorage.getItem("WxPayFlag") == "1") {
                Lanmao.loading.show("支付查询验证中")
                alert(localStorage.getItem("BOSSouttradeno"))
                try {
                    let WxQueryData = await BossQueryOrderByOutTradeNo(
                        localStorage.getItem("BOSSouttradeno") //商户流水号
                    )
                    if (WxQueryData.code == 1) {
                        Lanmao.loading.hide()
                        Toast({
                            position: "bottom",
                            message: "支付成功开卡结束！！",
                        })
                        localStorage.removeItem("BOSSouttradeno")
                        localStorage.removeItem("WxPayFlag")
                    } else {
                        Lanmao.loading.hide()
                        Toast({
                            position: "bottom",
                            message: WxQueryData.msg,
                        })
                        localStorage.removeItem("BOSSouttradeno")
                        localStorage.removeItem("WxPayFlag")
                        this.$router.push("/UniversalPay")
                    }
                } catch (err) {
                    Toast({
                        position: "bottom",
                        message: "微信支付查询异常!!!",
                    })
                    Lanmao.loading.hide()
                }

            }
        },

        // 缴费
        async openPay() {
            // 获取微信支付链接接口
            Lanmao.loading.show("加载中！")
            try {
                var WxBossPayData = await WxBossPay({
                    phone: this.serviceid,
                    amount: `${this.amount}`,
                    recordNumber: this.recordNumber,
                })
                if (WxBossPayData.code != 1) {
                    Lanmao.loading.hide()
                    Toast({
                        position: "bottom",
                        message: WxBossPayData.msg,
                    })
                } else {
                    Lanmao.loading.hide()
                    let redirect_url = `${env.prod.baseUrl}/UniversalPay`
                    let AllformData = WxBossPayData.form
                    let wxUrl = AllformData + "&redirect_url=" + redirect_url
                    localStorage.setItem("BOSSouttradeno", WxBossPayData.outtradeno)
                    localStorage.setItem("WxPayFlag", "1")
                    window.location.href = wxUrl
                }
            } catch (err) {
                Toast({
                    position: "bottom",
                    message: "支付异常!!!",
                })
                Lanmao.loading.hide()
            }

        },
    },

    computed: {},

    watch: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
.UniversalPay {
    width: 100%;
    height: 100%;
    background: #ffffff;

    .pay_all {
        .Pay_header {
            width: 100%;
            height: px2rem(110);

            .OpenCard_header_title {
                width: 100%;
                height: 100%;
                color: #ffffff;
                background: #4881c4;
                font-weight: 600;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: px2rem(46);
                padding: px2rem(0) px2ren(40);

                p {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }

        .Pay_content {
            width: 100%;

            .Pay_content_price {
                width: 100%;
                height: px2rem(260);
                display: flex;
                justify-content: start;
                align-items: center;
                padding: px2rem(26);
                background: #ffffff;

                .Pay_content_price_logo {
                    width: 30%;
                    height: 100%;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .Pay_content_right {
                    width: 70%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-around;


                    p {
                        // margin-top: px2rem(60);
                        // margin-left: px2rem(26);
                        font-size: px2rem(36);
                        font-weight: 600;
                        color: #4881c4;

                        span {
                            color: red;
                            font-weight: 700;
                            font-size: px2rem(38);
                        }
                    }
                }


            }

            .Pay_content_mode {
                width: 100%;
                background: #ffffff;
                margin-top: px2rem(30);
                padding: 0 px2rem(26);
                font-size: px2rem(28);

                .title {
                    width: 100%;
                    height: px2rem(60);
                    font-size: px2rem(30);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-bottom: px2rem(1) solid #f1f1f1;
                }

                .selectPay {
                    width: 100%;

                    #payBox {
                        width: 100%;

                        .payWay {
                            height: px2rem(80);
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-top: px2rem(18);
                            border-bottom: px2rem(1) solid #f1f1f1;

                            .payWay_left {
                                width: 30%;
                                display: flex;
                                justify-content: start;
                                align-items: center;

                                img {
                                    width: px2rem(46);
                                    height: p2rem(46);
                                    margin-right: px2rem(10);
                                }
                            }

                            .chooseIcon {
                                width: px2rem(30);
                                height: px2rem(30);
                                display: flex;
                                border: px2rem(1) solid #4881c4;
                                border-radius: 50%;
                                // background: red;
                            }

                            .active {
                                width: px2rem(30);
                                height: px2rem(30);
                                display: flex;
                                background: url(../../assets/images/xz.png) no-repeat;
                                background-size: 100%;
                            }
                        }
                    }
                }
            }

            .btn {
                width: 100%;
                height: px2rem(80);
                margin-top: px2rem(30);
                display: flex;
                justify-content: center;
                align-items: center;

                button {
                    width: 86%;
                    height: 80%;
                    background: #4881c4;
                    color: #ffffff;
                    font-size: px2rem(32);
                    border-radius: px2rem(10);
                }
            }
        }
    }

    .login_tu {
        width: 100%;
        height: 100%;
        background: url(../../assets/images/login/login5.png) no-repeat;
        background-size: 100% 80%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        p {
            margin-bottom: px2rem(300);
            color: #1497ef;
        }
    }

    .login_tus {
        width: 100%;
        height: 100%;
        background: url(../../assets/images/login/login6.png) no-repeat;
        background-size: 100% 70%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        p {
            margin-bottom: px2rem(300);
            color: #1497ef;
        }
    }

}
</style>